import * as React from "react";
import MUIButton from "@mui/material/Button";
import SC from "./style.js";

const Button = (props) => {
  const {
    caption,
    leftIcon,
    rightIcon,
    tooltip,
    visible = true,
    subcaption,
    sx,
    isMobile,
    fontSize,
    color,
    ...rest
  } = props;

  if (!visible) return null;

  return (
    <MUIButton
      {...rest}
      sx={{
        ...sx,
        ...SC.MUIButtonrt,
      }}
    >
      {leftIcon && <SC.LeftButton>{leftIcon}</SC.LeftButton>}
      <SC.forprofile>
        <SC.Container fontSize={fontSize} color={color}>
          {caption}
        </SC.Container>
        {subcaption && <SC.Subcaption>{subcaption}</SC.Subcaption>}
      </SC.forprofile>
      {rightIcon && (
        <SC.RightButton style={{ color: color }}>{rightIcon}</SC.RightButton>
      )}
    </MUIButton>
  );
};

export default Button;
